<ng-container *transloco="let t;">

  <div class="p-grid">
    <div class="p-col-6">
      <h2>{{ t('common.labels.results') }}</h2>
    </div>
    <div class="p-col-6 p-text-right">
      <button withRight="admin.toolboxcandidate.edit" *ngIf="order.resources.length > 0" pButton (click)="onResend()" type="button" [disabled]="(sending === true) ? true : null" label="{{ t('toolbox_candidate_results.resend_report') }}" icon="pi pi-envelope" class="p-button-sm p-mb-2 autofocus"></button>
    </div>
  </div>

  <app-loader [loading]="loading"></app-loader>

  <ng-container *ngIf="loading !== true">
    <p *ngIf="order.resources.length === 0">{{ t('toolbox_candidate_results.no_reports') }}</p>
    <ng-container *ngIf="order.resources.length === 1">
      <p [innerHTML]="t('toolbox_candidate_results.one_report')"></p>
      <p *ngIf="order.report_sended !== null" [innerHTML]="t('toolbox_candidate_results.report_sended', { time: order.report_sended | amDateFormat: 'DD.MM.Y HH:mm' })"></p>
    </ng-container>
    <ng-container *ngIf="order.resources.length > 1">
      <p [innerHTML]="t('toolbox_candidate_results.more_reports', { amount: order.resources.length} )"></p>
      <p *ngIf="order.report_sended !== null" [innerHTML]="t('toolbox_candidate_results.reports_sended', { time: order.report_sended | amDateFormat: 'DD.MM.Y HH:mm' })"></p>
    </ng-container>
  </ng-container>

</ng-container>
